<template>
  <tbody>
    <template
      v-for="(item, index) in items"
      v-if="includeDraft(item) && (!showActive || hideOptions(item))"
    >
      <tr
        :key="item.id"
        :class="['workPermit__item', `workPermit__item-${ index % 2 ? 'odd' : 'even' }` ]"
      >
        <td>
          <i
            v-show="showCollapse(item)"
            :class="['tree-arrow pointer', item.collapsed ? 'fa-angle-right' : 'fa-angle-down', 'fa angle']"
            @click="switchArrow(item)"
          />
        </td>
        <td class="bold">
          {{ workPermitTypeLabel(item.type) }}
        </td>
        <td>
          <span
            :class="{'link_text': includeDraft(item)}"
            @click="includeDraft(item) && viewWorkPermit(item)"
          >
            {{ item.code || emptyValue }}
          </span>
        </td>
        <td>{{ item.workType || emptyValue }}</td>
        <td>{{ formatStatus(item.status) | customStatusLabel }}</td>
        <td>{{ getBuilding(item) || emptyValue }}</td>
        <td>{{ getFloors(item) }}</td>
        <td>{{ (item.contractor || {}).name || emptyValue }}</td>
        <td>{{ getDuration(item) }}</td>
      </tr>
      <tr
        v-for="hoisting in item.hoistings"
        v-show="!item.collapsed"
        v-if="!excludeDraftHoisting(hoisting)"
        :key="hoisting.id"
        :class="['workPermit__item', `workPermit__item-${ index % 2 ? 'odd' : 'even' }` ]"
      >
        <td><!-- placeholder --></td>
        <td>
          <span>{{ workPermitTypeLabel(hoisting.type) }}</span>
          <img
            v-if="hotWorkRequired(hoisting)"
            src="ic_hotwork.png"
            alt="hotwork"
          >
        </td>
        <td>
          <span
            :class="{'link_text': includeDraft(item)}"
            @click="includeDraft(item) && viewWorkPermit(item, hoisting.id)"
          >
            {{ hoisting.code || emptyValue }}
          </span>
        </td>
        <td>{{ hoisting.description || emptyValue }}</td>
        <td>{{ formatStatus(hoisting.status) | customStatusLabel }}</td>
        <td>{{ getBuilding(hoisting) || emptyValue }}</td>
        <td>{{ getFloors(hoisting) }}</td>
        <td>{{ (hoisting.contractor || {}).name || emptyValue }}</td>
        <td>{{ getDuration(hoisting) }}</td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import {get} from 'lodash'
import {mapGetters} from 'vuex'
import {
  getDuration,
  isStandaloneWpTenant,
  maskStatusForExternalUser} from '@/modules/workPermits/utils'
import navigation from '@/utils/navigation'
import {WORK_PERMIT_STATUS, WORK_PERMIT_TYPES} from '@/modules/workPermits/consts'
import { getBuilding, getStandaloneDetailRouteName } from '@/api/workPermit/util'
import { getWorkPermitTypeLabel } from './regionalWorkPermitLabels'

export default {
  name: 'WorkPermitTableBody',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showActive: {
      type: Boolean,
      default: false,
    },
    tenancyTabIndex: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      emptyValue: '--',
      getDuration,
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentTenancy']),
    ...mapGetters('user', ['isEngineer', 'currentUser']),
  },
  methods: {
    showCollapse (item = {}) {
      return get(item, 'hoistings.length')
    },
    formatStatus (status) {
      return this.isEngineer ? status : maskStatusForExternalUser(status)
    },
    includeDraft (wp) {
      return isStandaloneWpTenant(wp, this.currentUser) || !(wp.status === WORK_PERMIT_STATUS.DRAFT)
    },
    excludeDraftHoisting (hoisting) {
      return this.isEngineer && hoisting.status === WORK_PERMIT_STATUS.DRAFT
    },
    getBuilding,
    hotWorkRequired (item) {
      return item.type === WORK_PERMIT_TYPES.HOISTING && item.hotWork
    },
    workPermitTypeLabel (type) {
      return getWorkPermitTypeLabel(type)
    },
    switchArrow (item) {
      item.collapsed = !item.collapsed
      this.$forceUpdate()
    },
    getFloors (item) {
      if (item.isAllFloors) {
        return this.$t('workPermit.allFloors')
      } else {
        return get(item, 'floors.length') ? item.floors.join(', ') : this.emptyValue
      }
    },
    viewWorkPermit (wp, hoistingId) {
      const routeName = getStandaloneDetailRouteName(this.isEngineer, wp.isTenantProject)
      navigation.toPage(routeName, { id: wp.parentId || wp.id }, { hoistingId })
    },
    hideOptions (item) {
      return ![WORK_PERMIT_STATUS.EXPIRED, WORK_PERMIT_STATUS.ENDED, WORK_PERMIT_STATUS.CANCELLED].includes(item.status)
    },
  },
}
</script>

<style lang='scss' scoped>
  td, th {
    word-break: break-word;
    word-wrap: break-word;
    padding: 10px;
    .link_text {
      color: #1779ba;
      text-decoration: underline;
    }
    .link_text:hover {
      cursor: pointer;
    }
  }
</style>
